import { Ng2StateDeclaration } from '@uirouter/angular';
import { EditProfileComponent } from '@client/app/feature-modules/navigation/profile/edit-profile/components/edit-profile.component';

export const NAVIGATION_STATES: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.edit-profile',
        url: '/edit-profile',
        component: EditProfileComponent,
        data: {
            usesModernStyles: true,
        },
    },
];
